import { PromotionLogic, ISingleSetPromotionInterface } from '@gongxigames/framework/promotions/logic';

export class SingleSetPromotionLogic extends PromotionLogic<ISingleSetPromotionInterface> {
    public accept(callback: () => void): void {
        this.promotionInterface.setChoice('accept', callback);
    }

    public reject(callback: () => void): void {
        this.promotionInterface.setChoice('reject', callback);
    }

    public end(): void {
        this.promotionInterface.end();
    }
}
